import React from 'react';
import styled from 'styled-components';

import Skeleton from '@joinforma/ui/components/Skeleton';

const Container = styled.div`
  width: 100%;
  max-width: 880px;
  padding: 16px 0;
  margin: 0 auto;
`;

const TitleContainer = styled.div`
  margin-bottom: 10px;
`;

const DescriptionSkeleton = () => (
  <>
    <Skeleton height={20} />
    <Skeleton width="60%" height={20} />
  </>
);

const PageSkeleton = () => (
  <Container>
    <TitleContainer>
      <Skeleton width={200} height={20} />
    </TitleContainer>
    <Skeleton height={20} />
    <DescriptionSkeleton />
  </Container>
);

export default PageSkeleton;
